import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { actions as TrackingActions } from 'app/modules/tracking'
import { captureException } from 'utils/SentryHelpers'
import { makeDefaultFailedContainer } from 'components/container'
import { APP_URL, SLACK_CLIENT_ID } from 'constants/ResourcesConstants'
import HeaderBrand from 'components/nav/Header/HeaderBrand'
import IntegrationConnector from 'components/Integration/components/IntegrationConnector'
import Accordion from 'components/shared/Accordion'
import Slack from 'components/Integration/services/Slack'
import { renderLogoSVG } from 'components/Integration/helpers'
import style from './style.styl'
import IconSVG from 'svg-inline-react'
import caretSrc from '!svg-inline?removeSVGTagAttrs=false?removeTags=true!images/icons/caret-icon.svg'
import tinycolor from 'tinycolor2'
import ProfileDetailsPreview from './Preview'

const SLACK_LOGO_SRC = require('!svg-inline?removeTags=true!images/svg/slack-logo-with-name.svg')
let SLACK_OAUTH_PAYLOAD = {
  client_id: SLACK_CLIENT_ID,
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/slack`,
  state: ''
}
const SLACK_AUTH_URL = 'https://slack.com/oauth/authorize'

class SlackInstall extends Component {

  static defaultProps = {
    previewWidth: 414
  }

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  clearPostInstallAction() {
    const { org } = this.props
    this.context.app.queries.OrgPropertiesQueries.updateProperties(org.id, { postInstall: null }).then(() => {
      this.context.router.push({
        pathname: '/',
        query: { showSlackModal: true }
      })
    }).catch((err)=> {
      captureException(err)
    })
  }

  componentWillReceiveProps({ integrationStates }) {
    if (integrationStates['slackBot']) {
      this.clearPostInstallAction()
    }
  }

  handleSkip = () => {
    const { org, actions: { track }} = this.props
    track('Slack Install', { context: 'widget-onboarding', skipped: true })
    this.context.app.queries.OrgPropertiesQueries
      .updateProperties(org.id, { postInstall: null })
      .then(() => {
        const isUniversityUser = localStorage.getItem('userOnboardingForUniversity');
        if (isUniversityUser) {
          window.location.href = `${APP_URL}/university`
        }
        else {
          this.context.router.push('/')
        }

      })
  }

  render() {
    const title = renderLogoSVG(SLACK_LOGO_SRC)

    return (
      <div>
        <div className={style.WelcomeLayout}>
          <div className={style.Integration}>
            <div className={style.WelcomeTitle}>
              <HeaderBrand large={true}/>
              <div className="dsg-h1 color-blue">Connect to Slack</div>
              <p className="description">Connecting to Slack is easy and takes less than 2 min.</p>
            </div>
            <Accordion key="slackBot" title={title} locked={true}>
              <Slack suppressUI={true} {...this.props}/>
            </Accordion>
            {this.renderActionButtons()}
          </div>
        </div>
        {this.renderPreview()}
      </div>
    )
  }

  renderSkipButton = () => (
    <div className={style.NavButtons}>
      <div className="nav-button link skip" onClick={this.handleSkip}>
        Skip
        <IconSVG src={caretSrc}/>
      </div>
    </div>
  )

  renderActionButtons() {
    return (
      <div className="flex-center flex-column">
        <IntegrationConnector
          connectorType="button"
          integrationId="slackBot"
          isOauth={true}
          oauthLink={SLACK_AUTH_URL}
          oauthQueryParams={SLACK_OAUTH_PAYLOAD}
          trackingPayload={{ context: 'widget-onboarding' }}
          />
        {this.renderSkipButton()}
      </div>
    )
  }

  renderRightHeader = () => (
    <div className="link" onClick={this.handleSkip}>
      Go to Home
    </div>
  )

  getKey(prefix) {
    const { location } = this.props
    return `${prefix}-${location.pathname}`
  }

  renderPreview() {
    const { user, orgSettings } = this.props
    const { previewWidth, previewColor } = this.props
    const { backgroundColor } = orgSettings.theme
    const color = previewColor || tinycolor(backgroundColor).toHexString()
    const darkColor = tinycolor(color)
      .darken(15)
      .toHexString()
    const style = {
      width: previewWidth,
      backgroundImage: `linear-gradient(${color}, ${darkColor})`
    }
    const settings = orgSettings.toJS()
    return (
      <div className={style.WelcomePreview} style={style}>
        <ProfileDetailsPreview user={user} orgSettings={settings}/>
      </div>
    )
  }
}

const container = makeDefaultFailedContainer(SlackInstall, {
  listenTo: [
    'stores.OrgStore', 'stores.OrgSettingsStore', 'stores.OrgPropertiesStore', 'stores.UserStore', 'stores.IntegrationsStore'
  ],
  fetch: {
    org() {
      return this.app.stores.OrgStore.getOrFetchCurrentOrg()
    },
    user() {
      return this.app.stores.UserStore.getOrFetchCurrentUser()
    },
    orgSettings() {
      return this.app.stores.OrgSettingsStore.getOrgSettings()
    },
    orgProperties() {
      return this.app.stores.OrgPropertiesStore.fetchPropertiesForCurrentOrg()
    },
    integrationStates() {
      return this.app.stores.IntegrationsStore.fetchIntegrationStates()
    }
  }
})

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      track: TrackingActions.track,
    }, dispatch)
  }
}

export default connect(
  null,
  mapDispatchToProps
)(container)



// WEBPACK FOOTER //
// ./src/scripts/components/SlackInstall/index.js